import React from "react"
import { graphql } from "gatsby"
import Layout from "../components/layout"
import Seo from "../components/seo"
import Hero from "../components/hero"

const Report2026 = ({ data }) => {
  const heroContent = data.markdownRemark.frontmatter.hero

  return (
    <Layout classes="team">
      <Seo title={heroContent.title} />
      <Hero heroContent={heroContent} />
    </Layout>
  )
}

export const query = graphql`
  {
    markdownRemark(frontmatter: { template_key: { eq: "2026-report" } }) {
      frontmatter {
        title
        hero {
          small_title
          title
        }
      }
    }
  }
`

export default Report2026
